function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Page not found"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "The page you requested could not be found. Please double check the URL and try again or contact our support team for assistance."
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { t } from "ttag";
import { Button } from "antd";
import useTranslation from "../../hooks/useTranslation";
import Layout from "./Layout";
var HTTP404 = function(param) {
    var _param_scoped = param.scoped, scoped = _param_scoped === void 0 ? false : _param_scoped, _param_ctaText = param.ctaText, ctaText = _param_ctaText === void 0 ? "Go to Homepage" : _param_ctaText, _param_ctaHref = param.ctaHref, ctaHref = _param_ctaHref === void 0 ? "/" : _param_ctaHref;
    useTranslation();
    return /*#__PURE__*/ React.createElement(Layout, {
        scoped: scoped,
        title: t(_templateObject()),
        body: t(_templateObject1())
    }, ctaText && ctaHref ? /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: function() {
            return window.location.replace(ctaHref);
        }
    }, ctaText) : null);
};
export default HTTP404;
